import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface ArcheidosKeyType {
  archeidos: LocalesKey;
  characterEnchancer: LocalesKey;
  comparison: LocalesKey;
  completed: LocalesKey;
  createsHighQualityArchitecturalVisualizationsAndInteriorRendersBasedOnATextDescriptionParticularlyEffectiveForGeneratingConceptualViewsOfBuildingsInteriorDesignsAndArchitecturalPresentations: LocalesKey;
  generalEnchancer: LocalesKey;
  generationStarted: LocalesKey;
  imageGenerationFailedPleaseTryAgain: LocalesKey;
  imageGenerator: LocalesKey;
  input: LocalesKey;
  lockStrength: LocalesKey;
  originalRetention: LocalesKey;
  prompt: LocalesKey;
  reference: LocalesKey;
  renderingImage: LocalesKey;
  seed: LocalesKey;
  sourceImage: LocalesKey;
  steps: LocalesKey;
  styleTransfer: LocalesKey;
  transfersTheVisualStyleFromOneImageToAnotherWhilePreservingTheContentAndCompositionOfTheOriginalImageIdealForApplyingaSpecificColorSchemeLightingOrArtisticStyle: LocalesKey;
  version: LocalesKey;
}

export const archeidosKeys = keyPathMirror<ArcheidosKeyType, string>(
  {
    archeidos: null,
    characterEnchancer: null,
    comparison: null,
    completed: null,
    createsHighQualityArchitecturalVisualizationsAndInteriorRendersBasedOnATextDescriptionParticularlyEffectiveForGeneratingConceptualViewsOfBuildingsInteriorDesignsAndArchitecturalPresentations:
      null,
    generalEnchancer: null,
    generationStarted: null,
    imageGenerationFailedPleaseTryAgain: null,
    imageGenerator: null,
    input: null,
    lockStrength: null,
    originalRetention: null,
    prompt: null,
    reference: null,
    renderingImage: null,
    seed: null,
    sourceImage: null,
    steps: null,
    styleTransfer: null,
    transfersTheVisualStyleFromOneImageToAnotherWhilePreservingTheContentAndCompositionOfTheOriginalImageIdealForApplyingaSpecificColorSchemeLightingOrArtisticStyle:
      null,
    version: null
  },
  'models.archeidos.'
);
